import { useMetadataUser } from 'contexts/metadata-user-context';
import Icon from 'images/Icon.svg'
import { useEffect, useState } from 'react';
import { Link } from "react-router-dom";

const HeaderBannerAccount = () => {
    const { profile } = useMetadataUser();
    const url = window.location.pathname
    const [isShow, setIsShow] = useState<boolean | null>(null)

    useEffect(() => {
        if (profile) {
            setIsShow(profile.address === null)
        }

        if (url === '/account-billing') {
            setIsShow(null)
        }
    }, [profile])


    return (
        <>
            {isShow && (
                <header className="top-0 z-40 bg-[#4F46E5] flex justify-between px-3 py-4 items-center md:py-3 md:px-8">
                    <div className="flex flex-row items-center gap-2 md:gap-4 md:ml-10">
                        <img
                            src={Icon}
                            alt="Ícone de megafone"
                        />
                        <span
                            className="text-white font-medium text-[14px] md:text-[18px]"
                        >
                            Por favor, finalize seu cadastro em <strong>Meus Dados</strong>.
                        </span>
                    </div>
                    <Link
                        to="/account-billing"
                        className="ml-2 md:mr-10"
                    >
                        <button className="py-2 px-4 text-[#4F46E5] bg-white rounded-md">Finalizar</button>
                    </Link>
                </header>
            )}
        </>

    );
};

export default HeaderBannerAccount;